export const about = {
  name: "Dr. Yasser Dawa",
  title: "CEO, EIE for Educational Services",
  bio: `Dr. Yasser Dawa leads EIE with a clear mission: transform education through accreditation, school improvement, and future-ready learning systems. His leadership bridges global standards, regional experience, and a long track record of building educator capacity across Egypt and the wider MENA region.`,
  email: "contact@yasserdawa.com",
  phone: "01228828225",
  mobile: "+20 111 000 0000",
  address:
    "Cairo office: Apartment 14, Building 40, Wesal Compound, Al Shorouk, Cairo, Egypt",
  linkedin: "https://www.linkedin.com/in/yasser-dawa-b6a90341/",
};

export const eie = {
  name: "EIE Excellence in Education",
  tagline: "Building brighter school schemata that supports one mind at a time",
  motto: `"Education is the means of expanding minds and changing lives to improve communities."`,
  summary: `EIE is an educational services provider focused on school improvement, accreditation support, and institutional transformation across the region. We partner with schools, leaders, and communities to build sustainable learning systems that empower students and educators alike.`,
  mission: `EIE mission is to design, build, and enhance educational systems that operate according to the highest standards and optimal functionality in the market.`,
  vision: `EIE vision is to make professional learning, knowledge management, and creative enterprise thinking a living daily activity and sustainable way of superiority.`,
  ceoWords: `At EIE, our journey toward transforming education began with the founding of ASPIRE in 2013, where we introduced innovative models in teacher development and school counseling. Building on that success, we expanded through strategic partnerships with HRD Global Education, creating a powerful ecosystem dedicated to advancing educational excellence.

Today, EIE stands as a leading educational services provider, having successfully delivered accreditation support and services to over 80 schools across Egypt. We are committed to building future-ready learning systems that empower students, inspire educators, and create lasting impact.

Our approach is rooted in partnership. We work closely with clients as strategic allies, aligning on shared goals and delivering measurable outcomes. Through business ethics, market insight, and competitive strategy, we ensure sustainable success for every institution we support.

Technology is at the core of our transformation strategy. We integrate advanced solutions that enable personalized learning, real-time feedback, and seamless collaboration. Beyond the classroom, we champion community engagement as a key driver of meaningful education.`,
  biography: `Dr. Yasser Dawa is a visionary leader and educator with thirty years of experience in education. He founded and operated successful international schools and now serves as Director of Egypt & MENA Operations for the Western Association of Schools and Colleges (WASC), overseeing accreditation, quality assurance, and strategic partnerships for more than 150 schools in the region.`,
  education: [
    "M.Ed, American International College (Springfield, Massachusetts)",
    "Doctorate of Business Administration, Arab Academy for Banking and Financial Sciences",
  ],
  positions: [
    "CEO, EIE for Educational Services",
    "CEO, Massachusetts",
    "Owner and Founder, Big Aspire",
    "CEO and Delegate Chairman, HRD Global Education",
    "GM, International College of Benha",
    "Director of Egypt & MENA Operations, Western Association of Schools and Colleges (WASC)",
  ],
  conceptSteps: [
    {
      title: "Initial Meeting",
      description:
        "We begin with an introductory meeting to understand client needs, project potential, and shared expectations while collecting project data and responding to key inquiries.",
    },
    {
      title: "Needs Analysis",
      description:
        "We evaluate the situation on the ground and provide a detailed report of findings to define priorities and improvement opportunities.",
    },
    {
      title: "Market Study",
      description:
        "For new schools or established institutions, we conduct market and competitor analysis to align strategy with the local context and growth potential.",
    },
    {
      title: "School Improvement Plan",
      description:
        "We review existing improvement plans or build a new School Improvement Plan (SIP) together with the partner to align priorities and expectations.",
    },
    {
      title: "Action Plan",
      description:
        "Once the SIP is approved, we build the operation team, set short-term goals, and define KPIs to make success measurable and achievable.",
    },
  ],
  services: [
    {
      category: "Consultation",
      items: [
        "School Improvement Plan",
        "School Management",
        "School Branding",
        "School Establishment",
        "International Accreditation",
      ],
    },
    {
      category: "Infrastructure Services",
      items: [
        "Architecture",
        "Interior Design",
        "Landscape",
        "Consulting & Construction",
        "Advanced Network Solutions",
      ],
    },
    {
      category: "School Services",
      items: [
        "School Furniture",
        "Media Services",
        "Book Supply",
        "Marketing Campaigns",
        "Professional Uniform Manufacturing",
      ],
    },
  ],
  team: [
    {
      name: "Dr. Tamer Hegazy",
      photo: "/Team/Dr Tamer Hegazy.png",
      bullets: [
        "Doctorate of Business Administration",
        "Former AUC teacher",
        "Head of R&D at Ministry of Defense Language Institute (Retired Army General)",
        "Six U.S. diplomas in education, TEFL, language proficiency, and American culture",
        "Licensed NATO examiner for assessment and test administration",
        "Finnish education consultant at MK Bridge",
        "Managed the full MSA accreditation process for International College of Benha",
        "American school principal and accreditation team leader",
      ],
    },
    {
      name: "Eng. Mina Fayez",
      photo: "/Team/Dr Mina Fayez.png",
      bullets: [
        "Owner of Saint Mary International School",
        "Certified teacher trainer",
        "Accreditation team leader",
        "School branding consultant",
      ],
    },
    {
      name: "Ms. Asmaa Bahaa",
      photo: "/Team/Ms asmaa bahaa.png",
      bullets: [
        "Master of Education in International Teaching from Framingham State University",
        "19 years of experience in international teaching and accreditation",
        "School director for IG and American programs",
        "Academic and accreditation consultant",
        "Certified evaluator by Cognia",
        "Team reviewer at AIAA and volunteer accreditor with MSA",
      ],
    },
    {
      name: "Dr. Mohamed Talat",
      photo: "/Team/Dr mohamed talaat.png",
      bullets: [
        "Master of Education in International Teaching from the USA",
        "Former faculty member at Canadian International College in Cairo",
        "20 years of experience in education",
        "School director for IG and American programs",
        "Academic and accreditation consultant",
        "Former AUC teacher",
      ],
    },
    {
      name: "Mr. Hany Mofid",
      photo: "/Team/Mr hany mofid.png",
      bullets: [
        "Head sales manager at McGraw Hill and Cambridge University Press",
        "22 years in local and international educational publishing",
        "Former marketing officer at Hodder Education",
        "Content development and creation advisor",
        "Market analyst for educational publishing",
        "Participant in national projects including Etisalat educational development",
        "Opened new markets in Turkey and Sudan",
      ],
    },
    {
      name: "Ms. Elham Elsayed",
      photo: "/Team/Ms elham.png",
      bullets: [
        "12 years of experience in American schools",
        "Operations manager",
        "School head counselor for college admission",
        "Consultant on GPA and grading requirements for college admission",
        "Accreditation team member and consultant",
      ],
    },
    {
      name: "Ms. Omneya Zaky",
      photo: "/Team/Ms omnya zaki.png",
      bullets: [
        "12 years of experience in American schools",
        "Customer support counselor",
        "School event planner",
        "Extra-curricular activity consultant",
        "Teacher assistant trainer",
        "Accreditation team member",
      ],
    },
  ],
  partners: [
    {
      name: "Massachusetts",
      description:
        "An Egyptian organization improving education through engineering, technology, and school construction solutions.",
      link: "https://yasserdawa.com",
    },
    {
      name: "HRD Global Egypt",
      description:
        "A Kuwaiti consultancy offering HR, organizational development, training, and management solutions across public and private sectors.",
      link: "https://yasserdawa.com",
    },
    {
      name: "American Academy (AATC)",
      description:
        "A provider of language, management, IT, teaching programs, and international exam services in Egypt.",
      link: "https://yasserdawa.com",
    },
    {
      name: "BIG Group",
      description:
        "A growing Egyptian 360 organization offering furniture, media, and uniform manufacturing services.",
      link: "https://yasserdawa.com",
    },
    {
      name: "Edmentum",
      description:
        "A global K-12 digital education solutions provider supporting hybrid and fully digital learning programs.",
      link: "https://www.edmentum.com",
    },
    {
      name: "T-Line",
      description:
        "An architecture and interior design firm creating sustainable educational spaces with a personal client-led approach.",
      link: "https://yasserdawa.com",
    },
  ],
  contact: {
    deltaOffice:
      "El Takseem El Seyahi, Emara 84, Madkhal 1, El Dor El Awal, El Qanater El Khayreya, El Qalyubia, Egypt",
    cairoOffice:
      "Apartment 14, Building 40, Wesal Compound, Al Shorouk, Cairo, Egypt",
    phone: "01228828225",
  },
};
